<div class="app-info-review-container">
    <div class="app-info-review-card">
        <div>
            <div class="review-description">Please review the information below and click Edit to make changes. Once you are comfortable, please
                click submit to officially complete your application. You will receive an application submission number
                for your records.</div>

            <div class="card">
                <div class="inner-content">
                    <h2 class="h2-title">{{product}}</h2>

                    <div class="d-grid-2-1">
                        <div>
                            <div class="d-flex">
                                <div class="label">Applicant Name:</div>
                                <div>{{submittedApplicantName}}</div>
                            </div>
                            <div class="d-flex">
                                <div class="label">Effective Date:</div>
                                <div>{{effectiveDate}}</div>
                            </div>
                            <div class="d-flex">
                                <div class="label">Billing Information:</div>
                                <div style="width: 50%">{{billingInformation}}</div>
                            </div>

                        </div>
                        <div>
                            <div class="d-flex">
                                <div class="label">Medicare ID:</div>
                                <div>{{medicareNumber}}</div>
                            </div>
                            <div class="d-flex">
                                <div class="label">PCP CoPay:</div>
                                <div>{{pcpCoPay}}</div>
                            </div>
                            <div class="d-flex">
                                <div class="label">Monthly Premium:</div>
                                <div>${{monthlyPremium}}</div>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
        <div class="submit-container">
            <button mat-raised-button color="primary" type="submit" class="sButton" (click)="onSubmit()" [disabled]="isSubmitting">Submit</button>
        </div>
    </div>

</div>